/**
 * El micro-rótulo: versales espaciadas, pequeñas y sólidas.
 *
 * Es lo que sustituye a los 103 usos de `text-sm` y a los 61 usos del color de marca con alfa. La
 * jerarquía deja de ser opacidad y pasa a ser tamaño, peso y caja. Importa más de lo que parece:
 * con colores sólidos el contraste es una consulta a una tabla, mientras que con alfa depende de
 * lo que se pinte debajo, y eso no lo componía nadie a mano. De ahí salían los dos
 * incumplimientos de contraste con más superficie del proyecto.
 */

export interface RotuloProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** Etiqueta un control concreto. */
  readonly htmlFor?: string;
  readonly children: React.ReactNode;
}

export function Rotulo({
  htmlFor,
  className = '',
  children,
  ...resto
}: RotuloProps): React.JSX.Element {
  /*
   * **El `-me-[0.12em]` no es un ajuste a ojo: cancela un espacio que CSS pone y no se ve.**
   *
   * `letter-spacing` añade el espacio DESPUÉS de cada letra, incluida la última. Con 0,12em a
   * 13 px son 1,56 px que se quedan colgando a la derecha de la palabra, dentro de la caja: la
   * caja de «ALUMNADO» mide 82,48 px y la tinta 70. Metido en un contenedor con relleno
   * simétrico, eso descentra la palabra sistemáticamente hacia la izquierda, que es exactamente
   * lo que se veía en el rótulo del rol de la cabecera.
   *
   * El margen negativo del mismo tamaño devuelve la caja al ancho de la tinta.
   */
  const clases = [
    'text-micro text-text-dim font-display font-bold uppercase -me-[0.12em]',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  if (htmlFor !== undefined) {
    return (
      <label htmlFor={htmlFor} className={clases}>
        {children}
      </label>
    );
  }
  return (
    <span className={clases} {...resto}>
      {children}
    </span>
  );
}
